/**
 * This component sits in the app bar.  It provides a notification icon and if the user has 
 * unread notifications, it will display the count in a red badge.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import HelpIcon from '@mui/icons-material/Help';

import { Tooltip } from '@mui/material';


const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    helpicon: {
      marginTop: 3,
      marginRight: 10,
      width: 30,
      height: 30,
      color: "#444",
    }
});

class UserHelp extends Component {

    gotoHelpPage() {
      this.props.history.push(`/help`);
    }

    render() {
      const classes = this.props.classes;

      return (
        <Tooltip id="tooltip-h" title="Help" placement="bottom">
          <HelpIcon 
            className={classes.helpicon}
            onClick={() => {this.gotoHelpPage()}}
            color="secondary"
            >
          </HelpIcon>
        </Tooltip>
      );
    }
}
  
UserHelp.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(UserHelp);